import jsonColours from "./colours.json";

export type colour = {
  label: string;
  hex: string;
  light: boolean;
};

export type colourVariant = {
  identifier: string;
  inStock: boolean;
  handle?: string;
  selectedSwatch?: string;
  image?: string;
};

export const colours: { [key: string]: colour } = jsonColours;

export const defaultColour: colour = {
  label: "BLACK",
  hex: "#000000",
  light: false,
};

// findColour finds a colour from colours.json, if it doesn't exist it returns the default black colour
export function findColour(identifier: string): colour {
  const found = colours[identifier.toLowerCase()];
  if (!found) {
    return defaultColour;
  }
  return found;
}

export enum ColourOptionType {
  IMAGE = "image",
  SWATCH = "swatch",
}
